module.exports = __webpack_public_path__ + "static/media/3.3fd52151.jpg";